import {lazy} from 'react';

export const ProfileMessagesAsync = lazy(() =>
    import('./ProfileMessages')
);
